/* Preserve existing component implementations, including asynchronously inserted sections. */
const config = JSON.parse(document.getElementById('ox-component-modules').textContent);
const pending = new Map(config.modules);
const observer = new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) {
    if (node.nodeType === 1) scan(node);
  }
});
function load(selector, url) {
  pending.delete(selector);
  import(url).catch(error => {
    pending.set(selector, url);
    console.error('OrienX component could not load:', url, error);
  });
}
function scan(root) {
  if (!pending.size) return;
  const selectors = [...pending.keys()].join(',');
  if (!config.editor && !root.matches?.(selectors) && !root.querySelector(selectors)) return;
  for (const [selector, url] of pending) {
    if (config.editor || root.matches?.(selector) || root.querySelector(selector)) load(selector, url);
  }
}
scan(document);
observer.observe(document.body, {childList: true, subtree: true});
